// config.js

// Update before running npm run build to set config to either stage or prod
// const env = "local";
const env = "prod";


const config = {
  local: {
    firebaseProject: "raefton-app-dev",
    gCloud: "http://localhost:3000"
  },
  test: {
    firebaseProject: "raefton-app-dev",
    gCloud: "https://us-east1-raefton-app.cloudfunctions.net/app_test"
  },
  stage: {
    firebaseProject: "raefton-app-dev",
    gCloud: "https://us-east1-raefton-app.cloudfunctions.net/raefton-serverless-v3-stage-app"
  },
  prod: {
    firebaseProject: "raefton-app",
    gCloud: "https://us-east1-raefton-app.cloudfunctions.net/raefton-serverless-v3-prod-app"
  }
}

export default {
  serverUrl: config[env].gCloud,
  GOOGLE_MAPS_BROWSER_API_KEY: 'AIzaSyA2HbrLYkDntDljDpJFbR2vsUK0fIzL7Gw',
}

const FirebaseConfigs = {
  'raefton-app':{
    apiKey: "AIzaSyA2HbrLYkDntDljDpJFbR2vsUK0fIzL7Gw",
    authDomain: "raefton-app.firebaseapp.com",
    databaseURL: "https://raefton-app.firebaseio.com",
    projectId: "raefton-app",
    storageBucket: "raefton-app.appspot.com",
    messagingSenderId: "78850972521",
    appId: "1:78850972521:web:2e718736aaac71bc607bf8",
    measurementId: "G-MLBNM815ST"
  },
  'raefton-app-dev': {
    apiKey: "AIzaSyBpkTXMp7hS355wwuEVn-vBRKmZ1Ib6qVo",
    authDomain: "raefton-app-dev.firebaseapp.com",
    databaseURL: "https://raefton-app-dev.firebaseio.com",
    projectId: "raefton-app-dev",
    storageBucket: "raefton-app-dev.appspot.com",
    messagingSenderId: "1016921865125",
    appId: "1:1016921865125:web:0752ea9e81e277dd0a464c",
    measurementId: "G-HL39LB8NPK"
  }
};

export const firebaseProject = config[env].firebaseProject;

export const firebaseConfig = FirebaseConfigs[firebaseProject];

export const isProduction = env === "prod";


// WEBPACK FOOTER //
// ./src/config.js